import React from 'react';
import { Box, Card, CardContent, Skeleton } from '@mui/material';

interface HoldingCardSkeletonProps {
  // Removed isCompact since we're no longer using it
}

const HoldingCardSkeleton: React.FC<HoldingCardSkeletonProps> = () => {
  return (
    <Card
      elevation={0}
      sx={{
        background: (theme) =>
          theme.palette.mode === 'dark'
            ? 'rgba(35, 35, 35, 0.8)'
            : 'rgba(255, 255, 255, 0.9)',
        // REMOVED for performance: backdropFilter: 'blur(20px)',
        border: (theme) =>
          theme.palette.mode === 'dark'
            ? '1px solid rgba(255, 255, 255, 0.08)'
            : '1px solid rgba(0, 0, 0, 0.06)',
        borderRadius: 4,
        boxShadow: (theme) =>
          theme.palette.mode === 'dark'
            ? '0 4px 30px rgba(0, 0, 0, 0.3)'
            : '0 4px 30px rgba(0, 0, 0, 0.08)',
        overflow: 'hidden',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Header with logo and basic info */}
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Skeleton variant="circular" width={48} height={48} />
            <Box>
              <Skeleton variant="text" width={120} height={24} />
              <Skeleton variant="text" width={140} height={14} />
            </Box>
          </Box>

          <Box textAlign="right">
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="text" width={80} height={14} />
          </Box>
        </Box>

        {/* Main metrics row */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box>
            <Skeleton variant="text" width={80} height={14} sx={{ mb: 0.5 }} />
            <Box display="flex" alignItems="center" gap={1}>
              <Skeleton variant="text" width={90} height={20} />
              <Skeleton variant="rounded" width={60} height={20} />
            </Box>
          </Box>

          <Box textAlign="right">
            <Skeleton variant="text" width={70} height={14} sx={{ mb: 0.5 }} />
            <Box display="flex" alignItems="center" gap={1} justifyContent="flex-end">
              <Skeleton variant="circular" width={16} height={16} />
              <Skeleton variant="text" width={60} height={16} />
              <Skeleton variant="text" width={50} height={16} />
            </Box>
          </Box>
        </Box>

        {/* Footer with cost basis info */}
        <Box
          sx={{
            pt: 2,
            borderTop: (theme) =>
              theme.palette.mode === 'dark'
                ? '1px solid rgba(255, 255, 255, 0.08)'
                : '1px solid rgba(0, 0, 0, 0.06)',
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Skeleton variant="text" width={120} height={14} />
            <Skeleton variant="text" width={100} height={14} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default HoldingCardSkeleton;